import { render, staticRenderFns } from "./media-editor.vue?vue&type=template&id=35c463f3"
import script from "./media-editor.vue?vue&type=script&lang=js"
export * from "./media-editor.vue?vue&type=script&lang=js"
import style0 from "./media-editor.vue?vue&type=style&index=0&id=35c463f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports